export * from './model';
export * from './medicalScore.service';
export * from './medicalScore.slice';
export * from './medicalScore.hooks';
